<div class="container-fluid mb-3">
    <div class="d-flex flex-row justify-content-between align-items-center">
      <h2 class="title">GE Tag ID Statuses</h2>
      <div class="d-flex justify-content-center align-items-center">
        <button class="btn btn-primary btn-add button" (click)="exportDetails()">Export</button>
      </div>
    </div>
    <!-- <mat-card class="mt-2" style="font-size: 14px;">
      <div class="row">
        <div class="col-lg-8">
          <span>Search</span>
          <mat-form-field appearance="outline" class="w-100">
            <input matInput [maxLength]="50" [(ngModel)]="search" placeholder="Search">
            <mat-hint align="end">{{search?.length || 0}} / 50</mat-hint>
          </mat-form-field>
        </div>
        <div class="col-lg-2">
          <span>Status</span>
          <mat-form-field appearance="outline" class="w-100">
            <mat-select [(ngModel)]="status" name="incidentState">
              <mat-option *ngFor="let incidentState of statuses" [value]="incidentState.value">
                {{status.viewValue}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-lg-2 d-flex align-items-center justify-content-center">
          <button class="btn-add btn btn-outline-primary search-button" (click)="searchData()">Search</button>
        </div>
      </div>
    </mat-card> -->
  
    <div class="table-container">
      <table mat-table [dataSource]="dataSource" matSort class=" w-100 mt-4 custom-table" (matSortChange)="sortData($event)">
  
        <ng-container matColumnDef="incidentId">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Incident Number</th>
          <td mat-cell *matCellDef="let row"> {{row.incidentNumber}} </td>
        </ng-container>
  
        <ng-container matColumnDef="incidentStatus">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Incident Status</th>
          <td mat-cell *matCellDef="let row"> {{row.incidentState}} </td>
        </ng-container>
  
        <ng-container matColumnDef="supplierName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Supplier Name</th>
          <td mat-cell *matCellDef="let row"> {{row.supplierName}} </td>
        </ng-container>
  
        <ng-container matColumnDef="gslNumber">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>GSL Number</th>
          <td mat-cell *matCellDef="let row"> {{row.gslNumber}} </td>
        </ng-container>
  
        <ng-container matColumnDef="date">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Date Tags Needed</th>
          <td mat-cell *matCellDef="let row"> {{row.date | date:'yyyy-MM-dd'}} </td>
        </ng-container>
  
        <ng-container matColumnDef="isNewSupplier">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>New Supplier</th>
          <td mat-cell *matCellDef="let row"> {{row.isNewSupplier}} </td>
        </ng-container>
  
        <ng-container matColumnDef="updateDate">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Updated Date</th>
          <td mat-cell *matCellDef="let row"> {{row.updatedDate | date:'yyyy-MM-dd'}} </td>
        </ng-container>
  
        <ng-container matColumnDef="updateBy">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Updated By</th>
          <td mat-cell *matCellDef="let row"> {{row.updatedBy}} </td>
        </ng-container>
  
        <ng-container matColumnDef="action">
          <th mat-header-cell *matHeaderCellDef style="text-align: center;">Action</th>
          <td mat-cell *matCellDef="let row" style="text-align: center;">
            <div class="d-flex justify-content-center align-items-center">
              <span [ngClass]="row.incidentState !=='COMPLETED' && row.incidentState !== 'REJECTED' ? 'material-icons update' : 'material-icons preview'" (click)="updateStatus(row)" style="cursor: pointer;"
                [matTooltip]="'View/ Update Status'"></span>
            </div>
          </td>
        </ng-container>
  
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </div>
  </div>
  